require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tutorials-examples-circuit-breaker.json") })
        }
      }, "path---tutorials-examples-circuit-breaker");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tutorials-examples-circuit-breaker!./.cache/json/tutorials-examples-circuit-breaker.json
// module id = 772
// module chunks = 231608221292675